import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_learn-18110_add-training-summary-mark-as-done'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
